import "./App.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import { Home, Login, Signup, OnlineBooking, Booking, Aboutus } from "./pages";
import Footer from "./components/Footer";
import ScrollButton from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/accomodations" exact element={<OnlineBooking />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/signup" exact element={<Signup />} />
        <Route path="/aboutus" exact element={<Aboutus />} />
      </Routes>
      <Footer />
      <ScrollButton />
    </div>
  );
}

export default App;
